<template>
  <section :class="['innerWrap', { in: open }]" ref="innerWrap">
    <div>
      <nav-header v-if="current" :session="session" :step="current" :next="next" :prev="prev" :msg="text"/>
      <slot></slot>
    </div>
  </section>
</template>

<script>
import NavHeader from '@/components/financeiro/negocieja/app/navigation/NavHeader.vue'

import { gsap } from "gsap"

export default {
  components: {
    NavHeader
  },
  props: {
    state: {
      type: Boolean
    },
    session: {
      type: String
    },
    step: {
      type: String
    },
    steps: {
      type: Array
    },
    msg: {
      type: String
    },
  },
  watch: {
    state ( value ) {
      this.open = value
      this.toggle()
    },
    msg ( value ) {
      if ( value ) {
        console.log('msg:', value)
        this.text = value
      }
    },
    step ( value ) {
      if ( value ) {
        this.setNav()
      }
    }
  },
  data () {
    return {
      open: false,
      next: null,
      prev: null,
      current: null,
      text: null
    }
  },
  mounted () {
    this.toggle()
    
    if ( this.step ) {
      this.setNav()
    }

    if ( this.msg ) {
      this.text = this.msg
    }
  },
  methods: {
    toggle() {
      this.open = this.state
      // console.log("open:", this.open)
      if ( this.open ) {
        this.setNav()
        gsap.fromTo(
          this.$refs.innerWrap,
          {
            transform: 'scale(2)',
            opacity: 0 
          },
          {
            transform: 'scale(1)', 
            opacity: 1,
            duration: .5, 
            ease: "circ.out"
          }
        )
      } else {
        gsap.fromTo(
          this.$refs.innerWrap,
          {
            transform: 'scale(1)',
            opacity: 1
          },
          {
            transform: 'scale(2)', 
            opacity: 0,
            duration: .5, 
            ease: "back.out(1.7)"
          }
        )
      }
    },
    setNav () {
      const current = this.steps.findIndex(step => step.slug === this.step)
      console.log("current:", current)
      const nextIndex = current + 1
      this.next = this.steps[nextIndex] ? this.steps[nextIndex] : null

      const prevIndex = current - 1
      this.prev = this.steps[prevIndex] ? this.steps[prevIndex] : null
      
      this.current = this.steps[current].title
    }
  }
}
</script>

<style lang="scss" scoped>
  .innerWrap {
    display: block;
    width: 100%; height: 100vh;
    position: absolute; top: 0; left: 0;
    z-index: 101;
    padding: 90px 0 0 0;
    overflow: hidden;
    background-image: 
      radial-gradient(circle at top left, #f7f8fc, #f3f5fb, #eef2fa, #e9eff9, #e3ecf8, #e0ebf7, #deeaf7, #dbe9f6, #dbe9f6, #dbe9f6, #dbe9f6, #dbe9f6);
    pointer-events: none;

    @media screen and ( max-height: 689px ) {
      padding: 80px 0 0 0;
    }

    &.in {
      pointer-events: all;
      // transform: translateX(0);
    }

    >div {
      height: 100%;
      display: flex; align-items: stretch;
      flex-direction: column;
    }
  }


</style>